import {useTranslation} from 'react-i18next';
import AppButton from '../../../components/common/AppButton';
import {SVG} from '../../../constants/assetLists';

type Props = {
  answeredCount: number;
  totalQuestions: number;
  isFirstPage: boolean;
  isLastPage: boolean;
  isSubmitting?: boolean;
  onNext: () => void;
  onPrev: () => void;
  onSubmit: () => void;
  onClearForm: () => void;
};

function PublicFormNavBar({
  answeredCount,
  totalQuestions,
  isFirstPage,
  isLastPage,
  isSubmitting = false,
  onNext,
  onPrev,
  onSubmit,
  onClearForm,
}: Props) {
  const {t} = useTranslation();

  const progressPercent =
    totalQuestions > 0 ? (answeredCount / totalQuestions) * 100 : 0;

  return (
    <div className="w-full bg-white px-6 py-3 flex-shrink-0 flex flex-col gap-3">
      {/* Progress bar */}
      <div className="w-full max-w-[568px] h-[9px] bg-gray90 overflow-hidden flex flex-row-reverse md:hidden">
        <div
          className="h-full bg-tealBlue transition-all duration-300 ease-out"
          style={{width: `${progressPercent}%`}}
        />
      </div>

      <div className="flex justify-around items-center gap-4">
        {/* Clear form */}
        <button
          type="button"
          onClick={onClearForm}
          className="text-[16px] text-linkBlue underline font-medium whitespace-nowrap hover:opacity-80 transition-opacity">
          {t('forms.public.clearForm')}
        </button>

        {/* Progress bar */}
        <div className="w-full max-w-[568px] h-[9px] bg-gray90 overflow-hidden hidden md:flex flex-row-reverse">
          <div
            className="h-full bg-tealBlue transition-all duration-300 ease-out"
            style={{width: `${progressPercent}%`}}
          />
        </div>

        {/* Navigation buttons */}
        <div className="flex items-center gap-3">
          {/* Prev button */}
          <AppButton
            variant="secondary"
            py="8px"
            px="24px"
            disabled={isFirstPage}
            iconStart={
              <img
                src={
                  isFirstPage ? SVG.greaterThanGrayIcon : SVG.greaterThanIcon
                }
                alt=""
                className="w-[10px] h-[10px] object-contain"
              />
            }
            onClick={onPrev}>
            {t('forms.public.prev')}
          </AppButton>

          {/* Submit or Next button */}
          {isLastPage ? (
            <AppButton
              variant="primary"
              py="8px"
              px="24px"
              disabled={isSubmitting}
              isLoading={isSubmitting}
              onClick={onSubmit}>
              {t('forms.public.submit')}
            </AppButton>
          ) : (
            <AppButton
              variant="primary"
              py="8px"
              px="24px"
              iconEnd={
                <img
                  src={SVG.lessThanWhiteIcon}
                  alt=""
                  className="w-[10px] h-[10px] object-contain"
                />
              }
              onClick={onNext}>
              {t('forms.public.next')}
            </AppButton>
          )}
        </div>
      </div>
    </div>
  );
}

export default PublicFormNavBar;
